import { makeStyles } from '@material-ui/core';

export const styles = makeStyles({
    container: {
        padding: '24px 40px',
        border: 'solid 2px #e8ecf2',
        borderRadius: '6px',
        flex: '1 0 250px'
    },
    title: {
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        '& img': {
            marginInlineEnd: '6px'
        }
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'flex-end'
    }
});
